import { useTranslation } from 'react-i18next';
import { useNavigate } from '@tanstack/react-router';
import { FormEvent, useEffect, useState } from 'react';
import { Loader, Pagination } from 'app/components';
import { useLabels } from 'entities/label';

import LabelDownloadButton from 'features/admin-labels/LabelDownloadButton';
import LabelImportButton from 'features/admin-labels/LabelImportButton';

interface LabelRow {
  id: number;
  key: string;
  text: string;
  locale: string;
  visibility: string;
}

const Labels = () => {
  const { t } = useTranslation(['common', 'label', 'labels', 'reset']);

  const navigate = useNavigate();

  const [keySearch, setKeySearch] = useState('');
  const [textSearch, setTextSearch] = useState('');
  const [page, setPage] = useState(0);

  const { data, isLoading, refetch } = useLabels({ key: keySearch, text: textSearch, page });

  useEffect(() => {
    onSearch();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  function handleListClick(label: LabelRow) {
    navigate({ to: '/admin/labels/$id', params: { id: label?.key } });
  }

  function handleNewClick() {
    navigate({ to: '/admin/labels/new' });
  }

  function onReset() {
    setTextSearch('');
    setKeySearch('');
    setPage(0);
  }

  function onSearch(e?: FormEvent) {
    if (e) {
      e.preventDefault();
    }

    refetch();
  }
  function renderContent() {
    if (isLoading || !data) {
      return <Loader />;
    }

    return (
      <>
        <table>
          <thead>
            <tr>
              <th>{t('label:key')}</th>
              <th>{t('label:text')}</th>
              <th>{t('label:locale')}</th>
              <th>{t('label:visibility')}</th>
            </tr>
          </thead>
          <tbody>
            {(data.items as LabelRow[]).map((item) => {
              return (
                <tr key={item.id} onClick={() => handleListClick(item)}>
                  <td>{item.key}</td>
                  <td>{item.text}</td>
                  <td>{item.locale}</td>
                  <td>{item.visibility}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <Pagination onPaginate={(page: number) => setPage(page)} page={data.page} pageSize={20} />
      </>
    );
  }

  return (
    <>
      <div className="content-title columns two mb-2">
        <h1 className="">{t('label:title')}</h1>
        <div className="justify-self-end d-flex">
          <LabelDownloadButton />
          <LabelImportButton />
          <button className="btn btn-primary me-2" onClick={handleNewClick}>
            <i className="fa fa-plus" /> {t('labels:new')}
          </button>
        </div>
      </div>
      <form className="search-field-wrapper row align-items-end" onSubmit={onSearch}>
        <div className={'search-field form-group col'}>
          <label className="search-field-label">{t('label:key')}</label>
          <input className="form-control" value={keySearch} onChange={(e) => setKeySearch(e.target.value)} />
        </div>
        <div className={'search-field form-group col'}>
          <label className="search-field-label">{t('label:text')}</label>
          <input className="form-control" value={textSearch} onChange={(e) => setTextSearch(e.target.value)} />
        </div>
        <div className="col">
          <button className="btn btn-primary">{t('common:search')}</button>
          <button className="btn btn-secondary" type="button" onClick={onReset}>
            {t('reset:field')}
          </button>
        </div>
      </form>
      {renderContent()}
    </>
  );
};

export default Labels;
